import types from "../actions/types";

const initialState = {
  plans: null,
  selectedIndex: -1,
  prevDateTime: -1,
  nextDateTime: -1,
  numberOfEmptyIntervals: 0,
  oneRequestBeforeMidNight: false,
  prevBatchLength: 0,
  nextBatchLength: 0,
  flex: {},
  reachedStartOfDay: false,
  reachedEndOfDay: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_REISADVIEZEN:
      return Object.assign({}, state, {
        formConfig: action.formConfig,
        formValues: action.formValues,
        loading: true,
        nextItinerariesLoading: false,
        prevItinerariesLoading: false,
        noPrevResponseForInterval: false,
        noNextResponseForInterval: false,
        oneRequestBeforeMidNight: false,
        flex: {},
        plans: [],
      });
    case types.REQUEST_REISADVIEZEN_FAILED:
      if (action.isPageRequest) {
        return Object.assign({}, state, {
          loading: false,
        });
      }
      return Object.assign({}, state, {
        plans: [],
        selectedIndex: -1,
        loading: false,
      });
    case types.RECEIVED_REISADVIEZEN:
      const selectedIndex = action.plans.findIndex((plan) => !plan.cancelled);

      //let isTexelhopperFlexAvailable1 = state.isTexelhopperFlexAvailable
      let flex1 = {
        ...state.flex,
      };

      // Manually set to false and remove because tripAvailable is also true on line 28
      // if(state.flex && state.flex.texelhopper) {
      //   isTexelhopperFlexAvailable1 = !(action.plans && action.plans.length);
      //   if(!isTexelhopperFlexAvailable1) {
      //     delete flex1.texelhopper
      //   }
      // }

      return Object.assign({}, state, {
        flex: flex1,
        //isTexelhopperFlexAvailable: isTexelhopperFlexAvailable1,
        formConfig: action.formConfig,
        formValues: action.formValues,
        metadata: action.metadata,
        prevTime: action.prevTime,
        nextTime: action.nextTime,
        plans: action.plans,
        plannerType: action.plannerType,
        origin: action.origin,
        destination: action.destination,
        targetIsArrivalTime: action.targetIsArrivalTime,
        selectedDate: action.selectedDate,
        selectedIndex,
        loading: false,
        startPageIndex: action.startPageIndex,
        endPageIndex: action.endPageIndex,
      });
    case types.SELECTED_REISADVIES:
      return Object.assign({}, state, {
        plans: state.plans,
        selectedIndex: action.selectedIndex,
      });
    case types.REQUEST_FLEX_REISADVIEZEN:
      action.formValues = Object.assign({}, action.formValues);
      delete action.formValues.flex;
      if (
        JSON.stringify(state.formValues) !== JSON.stringify(action.formValues)
      )
        return state;

      return Object.assign({}, state, {
        flex: Object.assign({}, state.flex, {
          [action.flexType]: {
            isRequired: !!action.formConfig.submit.isRequired,
            loading: true,
          },
        }),
      });
    case types.REQUEST_FLEX_REISADVIEZEN_FAILED:
      action.formValues = Object.assign({}, action.formValues);
      delete action.formValues.flex;
      if (
        JSON.stringify(state.formValues) !== JSON.stringify(action.formValues)
      )
        return state;

      return Object.assign({}, state, {
        flex: Object.assign({}, state.flex, {
          [action.flexType]: {
            loading: false,
          },
        }),
      });
    case types.RECEIVED_FLEX_REISADVIEZEN:
      action.formValues = Object.assign({}, action.formValues);
      delete action.formValues.flex;
      if (
        JSON.stringify(state.formValues) !== JSON.stringify(action.formValues)
      )
        return state;

      //let isTexelhopperFlexAvailable2 = state.isTexelhopperFlexAvailable
      let flex2 = Object.assign({}, state.flex, {
        [action.flexType]: {
          information: action.flexInformation,
          plannerType: action.plannerType,
          loading: false,
        },
      });

      // Manually set to false and remove because tripAvailable is also true on line 28
      // if(action.flexType === 'texelhopper') {
      //   isTexelhopperFlexAvailable2 = !(state.plans && state.plans.length) && action.flexInformation.tripAvailable;
      //   if(!isTexelhopperFlexAvailable2) {
      //     delete flex2.texelhopper
      //   }
      // }

      return Object.assign({}, state, {
        //isTexelhopperFlexAvailable: isTexelhopperFlexAvailable2,
        flex: flex2,
      });
    case types.REQUEST_REISADVIEZEN_NEXT:
      return Object.assign({}, state, {
        nextItinerariesLoading: true,
      });
    case types.REQUEST_REISADVIEZEN_PREV:
      return Object.assign({}, state, {
        prevItinerariesLoading: true,
      });
    case types.RECEIVED_REISADVIEZEN_PREV:
      return Object.assign({}, state, {
        plans: [...action.plans, ...state.plans],
        plannerType: action.plannerType,
        prevTime: action.prevDateTime,
        noPrevResponseForInterval: action.noPrevResponseForInterval,
        numberOfEmptyIntervals: action.noPrevResponseForInterval
          ? state.numberOfEmptyIntervals + 1
          : state.numberOfEmptyIntervals,
        selectedIndex: state.selectedIndex + action.prevBatchLength,
        prevItinerariesLoading: false,
      });
    case types.RECEIVED_REISADVIEZEN_NEXT:
      return Object.assign({}, state, {
        plans: [...state.plans, ...action.plans],
        plannerType: action.plannerType,
        nextTime: action.nextDateTime,
        noNextResponseForInterval: action.noNextResponseForInterval,
        numberOfEmptyIntervals: action.noNextResponseForInterval
          ? state.numberOfEmptyIntervals + 1
          : state.numberOfEmptyIntervals,
        nextItinerariesLoading: false,
      });
    case types.REQUEST_BEFORE_MIDNIGHT:
      return Object.assign({}, state, {
        oneRequestBeforeMidNight: true,
      });
    case types.SET_REACHED_END_OF_DAY:
      return Object.assign({}, state, {
        reachedEndOfDay: action.reachedEndOfDay,
      });
    case types.SET_REACHED_START_OF_DAY:
      return Object.assign({}, state, {
        reachedStartOfDay: action.reachedStartOfDay,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/reisadviezen.js